import { BASE_URL_SETTING } from '../routes.constants'
import type { Route } from '~/interfaces/routes.interfaces'

const base = `${BASE_URL_SETTING}/myrdp`

export const SETTINGS_MYRDP_USER: Route = {
  path: `${base}/user`
}
